/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DownloadAttachment$Params {
  messageReference: string;
  index?: number;
}

export function downloadAttachment(http: HttpClient, rootUrl: string, params: DownloadAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, downloadAttachment.PATH, 'get');
  if (params) {
    rb.path('messageReference', params.messageReference, {});
    rb.query('index', params.index, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

downloadAttachment.PATH = '/v1/api/ui/message/media/{messageReference}';
